import { useState, useEffect, type ComponentType } from 'react';
import { useCorporateBondScreenerSidebarFilterContext } from './useCorporateBondScreenerSidebarFilterContext';

export interface IWithDraftSyncProps {
  draftKey?: number,
}

const withDraftSync = <P extends object>(
  Component: ComponentType<P & IWithDraftSyncProps>,
): ComponentType<P> => {
  const WithDraftSync = (props: P) => {
    const { subscribe } = useCorporateBondScreenerSidebarFilterContext();
    const [draftKey, setDraftKey] = useState(0);

    useEffect(() => subscribe(() => setDraftKey((v) => v + 1)), [subscribe]);

    return <Component { ...props } draftKey={ draftKey } />;
  };

  WithDraftSync.displayName = `withDraftSync(${ Component.displayName ?? Component.name })`;

  return WithDraftSync;
};

export default withDraftSync;
